import React, { useState } from 'react'

import { useTranslation } from 'language/translator'

/* Molecules */
import FilterPopover from 'components_new/molecules/FilterPopover'

import { PeriodSelectorProps } from '.'
import { getPeriodFilterDisplayValue } from '../utils'
import PeriodMenuContent from './PeriodMenuContent'

const Desktop = (props: PeriodSelectorProps) => {
  const { showActive, size, sx } = props

  const [controlledOpen, setControlledOpen] = useState<boolean>(false)

  const handleClick = () => {
    setControlledOpen(true)
  }

  const handleClose = () => {
    setControlledOpen(false)
  }

  const { t } = useTranslation()

  return (
    <FilterPopover
      active={!!props.periodFilter}
      iconName="Period"
      onClick={handleClick}
      onClose={handleClose}
      open={controlledOpen}
      primary={t('date_filters', 'time_period')}
      secondary={getPeriodFilterDisplayValue(props.periodFilter, t)}
      showActive={showActive}
      size={size}
      sx={sx}
      tooltipTitle={t('date_filters', 'time_period')}
      tooltipValue={getPeriodFilterDisplayValue(props.periodFilter, t)}
    >
      {props.allowReset === false ? (
        <PeriodMenuContent
          allowReset={false}
          onClose={handleClose}
          onSubmit={props.onSubmit}
          periodFilter={props.periodFilter}
        />
      ) : (
        <PeriodMenuContent
          onClose={handleClose}
          onSubmit={props.onSubmit}
          periodFilter={props.periodFilter}
        />
      )}
    </FilterPopover>
  )
}

export default Desktop
